const firebaseConfig = {

  apiKey: "AIzaSyBo1WJUavYcXwrRnBqbg5EghLaokRsKDGQ",

  authDomain: "carhub-ace3f.firebaseapp.com",

  projectId: "carhub-ace3f",

  storageBucket: "carhub-ace3f.appspot.com",

  messagingSenderId: "1164372848",

  appId: "1:1164372848:web:a1c7d72cceebf37c543db5"

};

  export default firebaseConfig;